<template>
    <div class="container">
        <b-modal
            :model-value="modCrearTasa"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-3">
                    <div class="password-policy-title">
                        {{ labels.formInfoTitle }}
                    </div>
                    <div class="password-policy-item">
                        {{ labels.formInfoSubtitle }}
                    </div>
                </div>
                <b-col md="4" lg="12" class="p-0 mx-auto">
                    <b-form-group>
                        <label>{{ labels.tipoTasa }}</label>
                        <b-form-select v-model="form.tipoTasa" class="reset-input" autocomplete="off">
                            <option value="">{{ labels.select }}</option>
                            <option v-for="tipoTasa in listTipoTasa" :key="tipoTasa.id" :value="tipoTasa.tipo_tasa">{{ tipoTasa.descripcion }}</option>
                        </b-form-select>

                        <label>{{ labels.valor }}</label>
                        <b-form-input
                            v-model="form.valor"
                            type="number"
                            class="reset-input"
                        ></b-form-input>

                        <label>{{ labels.vigencia }}</label>
                        <b-form-input
                            v-model="form.vigencia"
                            type="date"
                            class="reset-input"
                        ></b-form-input>                        
                    </b-form-group>
                    <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                        <b-button
                            class="mr-2 reset-btn-secondary"
                            @click="cierraModal()"
                        >
                            {{ labels.close }}
                        </b-button>
                        <b-button
                            class="reset-btn-primary"
                            @click="guardarTasa()"
                        >
                            {{ labels.save }}
                        </b-button>
                    </div>
                </b-col>
            </div>
        </b-modal>
    </div>
</template>

<script>
import TipoTasas from '../../../services/TipoTasas'; 
import Tasa from '../../../services/Tasas'; 

export default {
    name : 'Crear',
    props:{
        modCrearTasa: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form : {
                tipoTasa : '',
                valor : null,
                vigencia : ''
            },
            listTipoTasa : [],
        }
    },
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Crear tasa',
                    save : 'Guardar',
                    close : 'Cerrar',
                    select : 'Seleccione...', 
                    tipoTasa : 'Tipo tasa',
                    valor : 'Valor',
                    vigencia : 'Vigencia',
                    formInfoTitle: "Datos de la tasa",
                    formInfoSubtitle: "Completa la información y guarda la nueva tasa."
                }
            }else{
                return {
                    title : 'Create rates',
                    save : 'Save',
                    close : 'Close',
                    select : 'Select...', 
                    tipoTasa : 'Rate type',
                    valor : 'Worth',
                    vigencia : 'Validity',
                    formInfoTitle: "Rate details",
                    formInfoSubtitle: "Complete the information and save the new rate."
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.cleanInp();
            this.$emit('cierraModal',false) 
        },
        guardarTasa(){

            if (!this.form.tipoTasa || !this.form.valor || !this.form.vigencia) {
                this.$toast.error("Campo(s) pendiente(s) por diligenciar");
                return;
            }

            const info = {
                tipoTasa : this.form.tipoTasa, 
                valor : this.form.valor, 
                vigencia : this.form.vigencia, 
                idUser : this.$store.state.userId 
            }
            // console.log(info); 
            Tasa.createTasa(info) 
            .then((res) => { 
                if(res.status == 201){ 
                    this.$toast.success(res.data.message) 
                    this.$emit("creado");
                    this.cierraModal();
                }
            })
            .catch((error) => {
                console.error(error);
                this.$toast.error("Ocurrió un error al guardar.");
            });
        },
        cleanInp(){
            this.form.tipoTasa = "";
            this.form.valor = "";
            this.form.vigencia = "";
        }
    },
    mounted(){
        TipoTasas.getAllTipoTasas() 
        .then((res) => { 
            // console.log(res.data.listTipoTasas); 
            this.listTipoTasa = res.data.listTipoTasas 
        })
        .catch((err) => { console.log(err) }) 
    }
}
</script>

<style>

</style>
